import { Button, Icons, List, useModalForm } from '@pankod/refine-antd'
import { IResourceComponentsProps, GetListResponse } from '@pankod/refine-core'
import Head from 'next/head'
import React from 'react'

import TagModalForm from '@resources/lms-management/tag/blocks/TagModalForm'
import { ProgramTag } from '@resources/lms-management/tag/types'
import { TCommonError } from 'src/interfaces/common'
import TagTableList from '@resources/lms-management/tag/blocks/TagTableList'
import { showErrorNotification } from '@resources/angkatan-ppg-management/utils'

const LMSProgramTagList: React.FC<
  IResourceComponentsProps<GetListResponse<ProgramTag>>
> = ({ options }) => {
  const {
    modalProps: createModalProps,
    formProps: createFormProps,
    show: createShow,
    close: createClose,
  } = useModalForm<{ id: string }, TCommonError, Omit<ProgramTag, 'id'>>({
    action: 'create',
    resource: 'program-tags',
    dataProviderName: 'lms',
    autoResetForm: true,
    redirect: false,
    successNotification: {
      message: 'Tag berhasil dibuat',
      type: 'success',
      description: 'Sukses',
    },
    errorNotification: (error) =>
      showErrorNotification(error, 'Terdapat gangguan saat membuat tag'),
  })

  return (
    <List
      title="Daftar Tag Program"
      headerButtons={() => (
        <Button
          icon={<Icons.PlusOutlined />}
          type="primary"
          onClick={createShow}
        >
          Tambah Tag
        </Button>
      )}
    >
      <Head>
        <title>LMS Admin | {options?.label}</title>
      </Head>

      <TagTableList />

      <TagModalForm
        formProps={createFormProps}
        modalProps={createModalProps}
        onClose={createClose}
        type="create"
      />
    </List>
  )
}

export { LMSProgramTagList }
